import { createSelector } from 'reselect'
import createIsCardCompletedSelector from '../../selectors/createIsCardCompletedSelector'

export const getId = (state, props) => {
  return props.cardContext.id
}

export const getBoardId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].boardId
}

export const getName = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].name
}

export const getIsArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

const createIsObservedSelector = () => createSelector(
  [
    (_, { cardContext }) => cardContext.id,
    state => state.kanbo.observedTags,
  ],
  (
    cardId,
    observedTags,
  ) =>
    observedTags.some(tag => tag === `card-${cardId}`)
)

export const getAllowCardRemove = (state, props) => {
  return state['view-board'].settings[state['view-board'].cards[props.cardContext.id].boardId].allowCardRemove
}

export const getIncomingMailsEnabled = (state, props) => {
  return state.kanbo.config.incomingMail
}

export const getIsTemplate = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isTemplate
}

const getIsBoardTemplate = (state, props) => state['view-board'].view[state['view-board'].cards[props.cardContext.id].boardId].isTemplate

export default () => createSelector(
  [
    getIsArchived,
    getId,
    getBoardId,
    getName,
    createIsObservedSelector(),
    getAllowCardRemove,
    getIncomingMailsEnabled,
    getIsTemplate,
    getIsBoardTemplate,
    createIsCardCompletedSelector(getId),
  ],
  (
    isArchived,
    id,
    boardId,
    name,
    isObserved,
    allowCardRemove,
    incomingMailsEnabled,
    isTemplate,
    isBoardTemplate,
    isCompleted,
  ) => ({
    isArchived,
    id,
    boardId,
    name,
    isObserved,
    allowCardRemove,
    incomingMailsEnabled,
    isTemplate,
    isBoardTemplate,
    isCompleted,
  })
)
